import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { Image } from "@/components/ui/image";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import i18n from '../../assets/i18n';
import { backendSyncImage } from "@/stores/thunks";
import * as MediaSelector from './MediaSelector';

import missingImg from '../../assets/images/missing.png';
import loadingImg from '../../assets/images/loading.png';
import blanImg from '../../assets/images/blank.png';

import useIsMounted from '../../hooks/mounted';
import { Platform } from "react-native";

export default function ImageSynced(props) {
    const dispatch = useDispatch()
    const [imgSrc, setImgSrc] = useState(MediaSelector.imageSrc(props.uri, props.refresh) || blanImg)
    const mounted = useIsMounted()
    const [retry, setRetry] = useState(true)

    const onLoad = (evt) => {
        // if (imgSrc && imgSrc != loadingImg) {
        //     console.log('Media shown', props.uri)
        // }
        // console.log('LOADED', props.uri, Date.now(), evt.nativeEvent, props, imgSrc)
    }

    const onError = (evt) => {
        console.log('IMAGE ERR', evt.nativeEvent?.error);
        if (retry) {
            setRetry(false)
            if (Platform.OS !== 'web' && props.uri != undefined && typeof props.uri != 'number' && !props.uri.startsWith('file:///')) {
                dispatch(backendSyncImage(props.sync || (props.isAvatar ? '/user/' + props.uri + '/userImage' : '/workflow/media/' + props.uri), props.uri)).then(result => {
                    if (null != result && mounted()) {
                        setImgSrc(MediaSelector.imageSrc(result, props.refresh))
                    } 
                })
            }    
            setImgSrc(loadingImg)
        } else {
            console.log('MISSING', props.uri, imgSrc)
            setImgSrc(missingImg)
        }
    }
    return (
        props.isAvatar ?
            <Avatar {...props}>
                <AvatarImage {...props} key={imgSrc} source={imgSrc} onLoad={onLoad} onError={onError} alt={i18n.t('global.missingImage')}></AvatarImage>
            </Avatar> :
            <Image {...props} key={imgSrc} source={imgSrc} onLoad={onLoad} onError={onError} alt={i18n.t('global.missingImage')} />
    )
}